import * as Raven from 'raven-js';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { CartModule } from './cart/cart.module';
import { CheckoutModule } from './checkout/checkout.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { ModalComponent } from './modal/modal.component';

import { SharedService } from './shared.service';
import { AppGuard } from './app-guard.service';
import { LandingComponent } from './landing/landing.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';

import { CookieModule } from 'ngx-cookie';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BASE_PATH } from './variables';
import { AppHttpInterceptor } from './app-http-interceptor';
import { WindowRefService } from './app-window.service';

Raven.config(environment.sentryUrl).install();

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    // Throw error if in dev mode. Otherwise there would be no error shown in browser console
    // If not in dev mode, capture error to sentry.
    if (!environment.production) {
      console.error(err);
    } else {
      Raven.captureException(err);
    }
  }
}

// the second parameter 'de' is optional
registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    LandingComponent,
    BreadcrumbsComponent,
    ModalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    CartModule,
    CheckoutModule,
    CookieModule.forRoot()
  ],
  providers: [
    AppGuard,
    WindowRefService,
    SharedService,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    {
      provide: BASE_PATH,
      useValue: environment.apiUrl
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: RavenErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
